/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/download_medium'
export default icon
